import React, { Component } from 'react';
// import $ from 'jquery';
// import 'jquery-ui-bundle/jquery-ui.css';
// import 'jquery-ui-bundle/jquery-ui.js';
// import Tabs from 'react-tabs-navigation';
import T from 'prop-types';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Draggable from 'react-draggable';
import TripsTab from './TripsTab';
// import TripTable from './TripTable';
import RoutesTable from './RoutesTable';
import SchedulesTable from './SchedulesTable';
import SchedulingOrderSlideCards from './SchedulingOrderSlideCards';
// import '../ExternalResources/css/jquery-ui.css';
// import '../ExternalResources/js/jquery-1.11.1.js';
// import '../ExternalResources/js/jquery-ui.js';
import { Steps } from 'antd';
import { Card } from 'antd';
import { Layout } from 'antd';
import { Table } from 'reactstrap';
import Slider from "react-slick";
import ChartSlideCards from './ChartSlideCards';
import Image from 'react-bootstrap/lib/Image';
import Grid from 'react-bootstrap/lib/Grid';
import { Row, Col } from 'antd';
import { Button as AntdBtn, Icon as AntIcn } from 'antd';
import { CardTitle } from 'reactstrap';
import { PieChart } from 'react-easy-chart';
import { BarChart } from 'react-easy-chart';

const Step = Steps.Step;
const { Header, Footer, Sider, Content } = Layout;

const steps = [{
    title: 'First',
    content: '<button onClick={(e) => this.handleBtnClkAll(e)}>Run All</button>',
}, {
    title: 'Second',
    content: 'Second-content',
}, {
    title: 'Last',
    content: 'Last-content',
}];

class BottomSideNav extends Component {
    constructor() {
        super();
        this.state = {
            cards: [],
            gseStatus: {}
        }

    }

    componentWillReceiveProps(nextProps) {
        this.initCards(nextProps);
        this.setState({gseStatus: nextProps.gseStatus});
    }

    initCards(nextProps) {

    }

    updateTimeSlotMin = (theTimeSlotMin) =>  {this.props.updateTimeSlotMin(theTimeSlotMin)}
    updateTimeSlotMax = (theTimeSlotMax) =>  {this.props.updateTimeSlotMax(theTimeSlotMax)}

    render() {
        // this.initTrips();
        /* var settings = {
            className: "center",
            centerMode: true,
            centerPadding: "60px",
            slidesToShow: 3,
            speed: 500,
            dots: true,
            infinite: false,
            arrows: true
        }; */
        const settings = {
            dots: true,
            className: "center",
            centerMode: true,
            infinite: false,
            centerPadding: "60px",
            slidesToShow: 1,
            speed: 500,
            swipeToSlide: true,
            focusOnSelect: true,
            variableWidth: true,
            rows: 1,
            slidesPerRow: 1
        };
        return (
            <Draggable
                // axis="y"
                // bounds="parent"
                handle=".handle"
                defaultPosition={{ x: 0, y: 0 }}
                position={null}
                grid={[25, 25]}
                onStart={this.handleStart}
                onDrag={this.handleDrag}
                onStop={this.handleStop}
            >
                {/*<div id="myRightTopNav" >
                    <SchedulesTable data={this.props.data} />
                </div>*/}
                {/*<div id="myRightTopNav" >
                    <Card bordered={false}>
                        {this.state.cards}
                    </Card>
                </div>*/}
                {/*<Card id="myRightTopNav" bordered={false}>
                    {this.state.cards}
                </Card>*/}
                {/*<Card id="myRightTopNav" bordered={false}>
                        <Card type="inner" bordered={false}>
                            Inner Card content
                        </Card>
                        <Card style={{ marginTop: 16 }} type="inner" bordered={false}>
                            Inner Card content
                        </Card>
                </Card>*/}
                <div id="myBottomNav" className="container" style={{border: '1px solid grey'}}>
                    <div style={{width: "100%", height: 30, backgroundColor: "rgba(255, 255, 255,0.8)", cursor: "pointer"}} className="handle">
                            {/*<label style={{float: "left", fontSize: "16px", fontWeight: "bold"}}>Analysis</label>
                            <span style={{float: "right"}}><label style={{fontSize: "16px", fontWeight: "bold"}}>&#8722;</label></span>*/}
                            <AntdBtn type="primary" onClick={(e) => this.props.handleBottomBtnAnalysis(e)} style={{float: "center"}}>Analytics<AntIcn type="down" /></AntdBtn>
                    </div>
                    {/* <div style={{ position: "relative", top: "-30" }}>
                        <SchedulingOrderSlideCards data={this.props.data} />
                    </div> */}
                    <div style={{ position: "relative" }}>
                        <ChartSlideCards gseStatus={this.state.gseStatus} data={this.props.data} activeSchedulingOrderCardIdx={this.props.activeSchedulingOrderCardIdx} updateTimeSlotMin={this.updateTimeSlotMin} updateTimeSlotMax={this.updateTimeSlotMax}/>
                    </div>
                </div>
            </Draggable>
        );
    }
}

export default BottomSideNav;



// WEBPACK FOOTER //
// ./src/Componets/BottomSideNav.js